export function CancelSVG({ width, height, viewBox }) {
	return (
		<svg
			width={width}
			height={height}
			viewBox={viewBox}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1" />
			<line
				x1="5"
				y1="5"
				x2="19"
				y2="19"
				stroke="currentColor"
				strokeWidth="1"
			/>
		</svg>
	)
}
